'use client';

import { useEffect, useRef } from 'react';

import { initPostHog, getPostHog } from '@/lib/posthog-client';

export type PostHogIdentity = {
  id: string;
  email?: string | null;
  name?: string | null;
} | null;

export function PostHogProvider({
  apiKey,
  apiHost,
  identity,
  children,
}: {
  apiKey: string;
  apiHost: string;
  identity: PostHogIdentity;
  children: React.ReactNode;
}) {
  const identifiedRef = useRef(false);

  useEffect(() => {
    if (!apiKey) return;
    initPostHog({ apiKey, apiHost });
  }, [apiKey, apiHost]);

  useEffect(() => {
    const ph = getPostHog();
    if (!ph) return;
    if (identity) {
      ph.identify(identity.id, {
        ...(identity.email ? { email: identity.email } : {}),
        ...(identity.name ? { name: identity.name } : {}),
      });
      identifiedRef.current = true;
    } else {
      if (identifiedRef.current) {
        // Clear person state only after a known login so anonymous page loads
        // preserve PostHog's own anonymous session.
        ph.reset();
        identifiedRef.current = false;
      }
    }
  }, [identity?.id, identity?.email, identity?.name]);

  return <>{children}</>;
}
